var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 21.4286C18.2795 21.4286 19.3696 20.9771 20.1733 20.1733C20.9771 19.3696 21.4286 18.2795 21.4286 17.1429C21.4286 16.0062 20.9771 14.9162 20.1733 14.1124C19.3696 13.3087 18.2795 12.8572 17.1429 12.8572C16.0062 12.8572 14.9162 13.3087 14.1124 14.1124C13.3087 14.9162 12.8572 16.0062 12.8572 17.1429C12.8572 18.2795 13.3087 19.3696 14.1124 20.1733C14.9162 20.9771 16.0062 21.4286 17.1429 21.4286Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.143 23.1428L20.1772 20.1771",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.42861C12 2.74662 11.7291 2.09257 11.2469 1.61033C10.7646 1.1281 10.1106 0.857178 9.42861 0.857178H0.857178V18H9.42861",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.42859V11.1429",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.42861C12 2.74662 12.2709 2.09257 12.7532 1.61033C13.2354 1.1281 13.8894 0.857178 14.5714 0.857178H23.1429V12.8572",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakActiveIcon);
export default __webpack_public_path__ + "static/media/break-active-icon.95043a4ce9454dbbd79e5f40adac51a7.svg";
export { ForwardRef as ReactComponent };